import {
  ArticleIcon,
  BagSimpleIcon,
  BeachBallIcon,
  BooksIcon,
  CertificateIcon,
  ChatsCircleIcon,
  ConfettiIcon,
  CornersOutIcon,
  MegaphoneIcon,
  CrownIcon,
  HandHeartIcon,
  Icon,
  HeadsetIcon,
  MedalIcon,
  InfoIcon,
  UserPlusIcon,
  ArrowsClockwiseIcon,
  LightningIcon,
  SpiralIcon,
  GraduationCapIcon,
} from "@phosphor-icons/react";

type Tones = Record<
  string,
  {
    icon: Icon;
    description: string;
  }
>;

export const EXPERIENCE_OBJECTIVES: Tones = {
  Support: {
    icon: HeadsetIcon,
    description: "src.data.tones.experienceObjectives.Support",
  },
  Persuade: {
    icon: MegaphoneIcon,
    description: "src.data.tones.experienceObjectives.Persuade",
  },
  Onboard: {
    icon: UserPlusIcon,
    description: "src.data.tones.experienceObjectives.Onboard",
  },
  Inform: {
    icon: InfoIcon,
    description: "src.data.tones.experienceObjectives.Inform",
  },
  Learn: {
    icon: GraduationCapIcon,
    description: "src.data.tones.experienceObjectives.Learn",
  },
  Engage: {
    icon: LightningIcon,
    description: "src.data.tones.experienceObjectives.Engage",
  },
  Retain: {
    icon: ArrowsClockwiseIcon,
    description: "src.data.tones.experienceObjectives.Retain",
  },
} as const;

export const TONES: Tones = {
  Professional: {
    icon: BagSimpleIcon,
    description: "src.data.tones.Professional",
  },
  Persuasive: {
    icon: SpiralIcon,
    description: "src.data.tones.Persuasive",
  },
  Instructive: {
    icon: BooksIcon,
    description: "src.data.tones.Instructive",
  },
  Motivational: {
    icon: MedalIcon,
    description: "src.data.tones.Motivational",
  },
  Conversational: {
    icon: ChatsCircleIcon,
    description: "src.data.tones.Conversational",
  },
  Empathetic: {
    icon: HandHeartIcon,
    description: "src.data.tones.Empathetic",
  },
  Humorous: {
    icon: BeachBallIcon,
    description: "src.data.tones.Humorous",
  },
  Authoritative: {
    icon: CrownIcon,
    description: "src.data.tones.Authoritative",
  },
  Storytelling: {
    icon: ArticleIcon,
    description: "src.data.tones.Storytelling",
  },
  Enthusiastic: {
    icon: ConfettiIcon,
    description: "src.data.tones.Enthusiastic",
  },
  Formal: {
    icon: CertificateIcon,
    description: "src.data.tones.Formal",
  },
  Neutral: {
    icon: CornersOutIcon,
    description: "src.data.tones.Neutral",
  },
} as const;
